import React, { Suspense, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { MultichainModal } from '@cai/shared/dapp';
import { ToastContainer } from 'react-toastify';
import { LoadingOverlay } from '../component/LoadingOverlay';
import { useDAppState } from '../context/DAppStateProvider';
import { translateErrorMessage } from '../utils';
import { txToast } from '../component/TxToast';
import { toast } from 'react-toastify';
import CvTopRail from './cv/CvTopRail';
import CvHeader from './cv/CvHeader';
import CvTokenTicker from './cv/CvTokenTicker';
import CvFooter from './cv/CvFooter';
import UsernameSetupModal from '../component/UsernameSetupModal';
import '../theme/cv-prototype.css';
import '../theme/cv-mint.css';
import '../theme/cv-link-fix.css';

const AppLayout = () => {
  const { activeState, withdrawMyProceeds } = useDAppState();
  const [isClaiming, setIsClaiming] = useState(false);

  const withdrawProceeds = async () => {
    if (!isClaiming && activeState?.weiProceeds) {
      setIsClaiming(true);
      try {
        const txLink = await withdrawMyProceeds();
        if (txLink.length) {
          txToast(
            `Claimed ${activeState.proceeds}${activeState.symbol} successfully`,
            txLink,
            undefined,
          );
        } else {
          throw Error('Claiming proceeds failed!!!');
        }
      } catch (e) {
        toast.error(`${translateErrorMessage(e)}`);
      }
      setIsClaiming(false);
    }
  };

  return (
    <div className="cv-app">
      <div className="cv-scan" aria-hidden="true" />
      <ToastContainer
        position="bottom-left"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover={false}
        theme="dark"
      />
      <CvTopRail />
      {activeState?.weiProceeds ? (
        <div className="cv-claim-bar" onClick={withdrawProceeds}>
          {isClaiming
            ? 'You are trying to claim proceeds. Please approve it in your wallet!!!'
            : `You have ${activeState.proceeds} ${activeState.symbol} to be claimed. Click here to claim it!!!`}
        </div>
      ) : null}
      <CvHeader />
      <MultichainModal />
      <UsernameSetupModal />
      <Suspense fallback={<LoadingOverlay />}>
        <Outlet />
      </Suspense>
      <CvFooter />
      <CvTokenTicker />
    </div>
  );
};

export default AppLayout;
